import { render } from "./SyncData.vue?vue&type=template&id=8283e088"
import script from "./SyncData.vue?vue&type=script&lang=js"
export * from "./SyncData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__